import React from "react";
import { Link } from "react-router-dom";

function Blueprint() {
  return (
    <>
      <section className=" ps text-center">
        <div className="container">
          <h2 className="hadding font1   mb-4 text-center">
            Your health blueprint at a glance{" "}
          </h2>
          <p className="mb-4 text-center">
            Your performance at a glance, from cardio health to lifestyle
            <br /> impact. Complex reports turned into practical, and
            personalized strategies.
          </p>
          <Link to="/casestudies" className="d-inline-flex btn  border-white gap-3">
            {" "}
            <i className="bi bi-arrow-up-right" /> See case studies
          </Link>
          <img
            src="/assets/img/glance.png"
            alt="glance"
            className="img-fluid mt-4 mt-md-5"
          />
        </div>
      </section>
    </>
  );
}

export default Blueprint;
